<div *ngIf="!busy && !connected">
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      Account ID:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="accountID" />
      </div>
    </div>
  </div>  <div class="row margin-top-8">
    <div class="col-md-4 label">
      Application ID:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="applicationID" />
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
    </div>
    <div class="col-md-8" style="text-align: end">
      <button type="button" (click)="SaveSettings()"[disabled]="accountID.length === 0" class="iso-round-button secondary">
        {{ 'messaging.connect' | translate }}
      </button>
    </div>
  </div>
</div>
